import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Typography, Button } from '@mui/material';
import React from 'react';
import useStyles from './styles';
export default function UpgradeEnrollTenantModal(_ref) {
  let trigger = _ref.trigger;
  const classes = useStyles();
  const features = [{
    title: 'Transperent allocation tables',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "table"
    })
  }, {
    title: 'Auto-generated statements',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "file-text"
    })
  }, {
    title: 'Resident portal acess',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    })
  }, {
    title: 'Paper correspondence',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail"
    })
  }, {
    title: 'Live support',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "phone"
    })
  }, {
    title: 'Extended compliance',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "auction"
    })
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: trigger,
    title: "Enroll resident in unit 06",
    variant: "middle",
    noFooter: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "Why you should upgrade to enroll resident?"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "By upgrading you will get all free features plus:"), /*#__PURE__*/React.createElement("div", {
    className: classes.featuresList
  }, features.map(feature => /*#__PURE__*/React.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.featureIcon
  }, feature.icon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, feature.title), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet."))))), /*#__PURE__*/React.createElement("div", {
    className: classes.featuresLink
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "share",
    fontSize: "small"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "Take me to pricing page"))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    fullWidth: true,
    'custom-attribute': '453-upgrade-enrol-tenant-modal'
  }, "Upgrade now"))));
}